import styled from "styled-components";

export const StyledRating = styled.div`
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
`;

export const StyledValue = styled.span`
    ${({ theme }) => theme.fonts.openSansBold};
    font-size: 14px;
    line-height: 1em;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.purple};
    margin-left: 10px;
`;